export enum EVictimsRace {
  Black = 'Negra',
  Indian = 'Indígena',
  Yellow = 'Amarela',
  White = 'Branca',
  Unknown = 'Não identificado'
}
